"use strict";
/*
 * Created on 15. 10. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

var __param = this && this.__param || function (paramIndex, decorator) {
  return function (target, key) {
    decorator(target, key, paramIndex);
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var typescript_ioc_1 = require("@logio/typescript-ioc");

var RealImpactValueConverter_1 = require("../../../impact/conversions/RealImpactValueConverter");

var SelloutReleaseTotalDTO_1 = require("../../model/sellout/SelloutReleaseTotalDTO");

var ApprovalStatusConverter_1 = require("../ApprovalStatusConverter");

var ReleaseActionFeasibilityConverter_1 = require("../ReleaseActionFeasibilityConverter");

var SelloutImpactRecordConverter_1 = require("./SelloutImpactRecordConverter");

var SelloutReleaseTotalDTOConverter_1 = require("./SelloutReleaseTotalDTOConverter");

var SelloutTargetConverter_1 = require("./SelloutTargetConverter");
/**
 * @author Radek Beran
 */


var SelloutReleaseTotalDTOConverterImpl =
/*#__PURE__*/
function (_SelloutReleaseTotalD) {
  _inherits(SelloutReleaseTotalDTOConverterImpl, _SelloutReleaseTotalD);

  function SelloutReleaseTotalDTOConverterImpl(approvalStatusConverter, releaseActionFeasibilityConverter, impactRecordConverter, realImpactValueConverter, selloutTargetConverter) {
    var _this;

    _classCallCheck(this, SelloutReleaseTotalDTOConverterImpl);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseTotalDTOConverterImpl).call(this));
    _this.approvalStatusConverter = approvalStatusConverter;
    _this.releaseActionFeasibilityConverter = releaseActionFeasibilityConverter;
    _this.impactRecordConverter = impactRecordConverter;
    _this.realImpactValueConverter = realImpactValueConverter;
    _this.selloutTargetConverter = selloutTargetConverter;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(SelloutReleaseTotalDTOConverterImpl, [{
    key: "toObject",
    value: function toObject(source, conversions) {
      var _this2 = this;

      return new SelloutReleaseTotalDTO_1.SelloutReleaseTotalDTO(source.categoryId, conversions.asObject(source, 'impact', function (doc) {
        return _this2.impactRecordConverter.toObject(doc, conversions);
      }), conversions.asObjectList(source, 'previousImpacts', function (doc) {
        return _this2.impactRecordConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'approvalStatus', function (doc) {
        return _this2.approvalStatusConverter.toObject(doc, conversions);
      }), conversions.asObjectList(source, 'actionFeasibilities', function (doc) {
        return _this2.releaseActionFeasibilityConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'realImpact', function (doc) {
        return _this2.realImpactValueConverter.toObject(doc, conversions);
      }), conversions.asObjectOpt(source, 'targets', function (doc) {
        return _this2.selloutTargetConverter.toObject(doc, conversions);
      }));
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this3 = this;

      var result = {};
      Object.assign(result, {
        categoryId: source.categoryId
      });
      Object.assign(result, {
        impact: this.impactRecordConverter.toDocument(source.impact, conversions)
      });
      Object.assign(result, {
        approvalStatus: source.approvalStatus !== null ? this.approvalStatusConverter.toDocument(source.approvalStatus, conversions) : null
      });
      Object.assign(result, {
        previousImpacts: conversions.asObjectArray(source, 'previousImpacts', function (impact) {
          return _this3.impactRecordConverter.toDocument(impact, conversions);
        })
      });
      Object.assign(result, {
        actionFeasibilities: conversions.asObjectArray(source, 'actionFeasibilities', function (actionFeasibility) {
          return _this3.releaseActionFeasibilityConverter.toDocument(actionFeasibility, conversions);
        })
      });

      if (source.realImpact) {
        Object.assign(result, {
          realImpact: this.realImpactValueConverter.toDocument(source.realImpact, conversions)
        });
      }

      Object.assign(result, {
        targets: source.targets !== null ? this.selloutTargetConverter.toDocument(source.targets, conversions) : null
      });
      return result;
    }
  }]);

  return SelloutReleaseTotalDTOConverterImpl;
}(SelloutReleaseTotalDTOConverter_1.SelloutReleaseTotalDTOConverter);

SelloutReleaseTotalDTOConverterImpl = __decorate([__param(0, typescript_ioc_1.Inject), __param(1, typescript_ioc_1.Inject), __param(2, typescript_ioc_1.Inject), __param(3, typescript_ioc_1.Inject), __param(4, typescript_ioc_1.Inject), __metadata("design:paramtypes", [ApprovalStatusConverter_1.ApprovalStatusConverter, ReleaseActionFeasibilityConverter_1.ReleaseActionFeasibilityConverter, SelloutImpactRecordConverter_1.SelloutImpactRecordConverter, RealImpactValueConverter_1.RealImpactValueConverter, SelloutTargetConverter_1.SelloutTargetConverter])], SelloutReleaseTotalDTOConverterImpl);
exports.SelloutReleaseTotalDTOConverterImpl = SelloutReleaseTotalDTOConverterImpl;